import { render, staticRenderFns } from "./CategoryOverview.vue?vue&type=template&id=624509e8&scoped=true"
import script from "./CategoryOverview.vue?vue&type=script&lang=js"
export * from "./CategoryOverview.vue?vue&type=script&lang=js"
import style0 from "./CategoryOverview.vue?vue&type=style&index=0&id=624509e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624509e8",
  null
  
)

export default component.exports